import React from 'react'

const CompanyStats = () => {
  return (
    <div className='stats'>
        <div className="container">
            <h1>3+</h1>
            <p>Team members across the USA</p>
        </div>
        <div className="container">
            <h1>20+</h1>
            <p>People and companies helped</p>
        </div>
    </div>
  )
}

export default CompanyStats